<template>
  <v-container>
    <div v-if="posts.length == 0">
      <v-skeleton-loader
        v-for="n in 10"
        :key="n"
        class="mx-auto"
        max-width="800"
        type="list-item-avatar-three-line"
        loading
      ></v-skeleton-loader>
    </div>

    <v-row v-for="post in posts" :key="post.slug">
      <v-hover
          v-slot:default="{ hover }"
          close-delay="100"
        >
        <v-card
          class="mx-auto my-2"
          max-width="800"
          style="cursor: pointer"
          outlined
          :elevation="hover ? 12 : 2"
          @click="go(post)"
        >
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">{{post.publishedDate.split('T')[0]}}</div>
              <v-list-item-title class="headline mb-1">{{ post.title }}</v-list-item-title>
              <v-list-item-subtitle v-html="post.content.brief"></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar
              tile
              size="80"
              color="grey"
            >
            
              <v-img :src="`https://res.cloudinary.com/hortusbox/image/upload/c_fit,h_160,w_160/${post.image.public_id}.jpg`"></v-img>
              </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-hover>
    </v-row>


    <br/>
    <br/>
    <br/>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    posts: []
  }),
  methods: {
    go (post) {
      this.$router.push(`/blog/post/${post.slug}`)
    }
  },
  mounted () {
    axios.get(process.env.VUE_APP_BASE_URL+'/api/post')
    .then( (res) => {
      this.posts = res.data
    })
    .catch( (err) => {
      console.log(err)
    })
  }  
}
</script>

<style scoped>
h1 {
  color: #0b755f;
}
</style>